import PropTypes from 'prop-types';
import { Form, Input, Button } from 'antd';
import { useErrorMessage } from '../../../utils/errorMessage';
import { useAuthContext } from '../../../contexts/AuthContext';

export const CommentForm = ({
  t,
  pensioner,
  setOpenEditCommentModal,
  setRefreshData,
  refreshData
}) => {
  const [form] = Form.useForm();
  const { message } = useErrorMessage();
  const { dispatchAPI } = useAuthContext();

  const handleSubmit = async (values) => {
    try {
      await dispatchAPI('PATCH', {
        url: `/pensioners/${pensioner._id}`,
        body: values
      });
      setRefreshData(!refreshData);
      setOpenEditCommentModal(false);
    } catch (error) {
      message(error);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{ comment: pensioner.comment }}
      onFinish={handleSubmit}
    >
      <Form.Item name="comment" label={t('pensioners.show.comment')}>
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {t('pensioners.show.save_comment')}
        </Button>
      </Form.Item>
    </Form>
  );
};

CommentForm.propTypes = {
  t: PropTypes.func.isRequired,
  pensioner: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    comment: PropTypes.string
  }).isRequired,
  setOpenEditCommentModal: PropTypes.func.isRequired,
  setRefreshData: PropTypes.func.isRequired,
  refreshData: PropTypes.bool.isRequired
};
